<ng-container *transloco="let t;">
    <div>
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header py-75 px-1 mt-50">
            <div class="linked-organization-inner">
                <div class="d-flex justify-content-start align-items-center">
                    <div class="user-page-info">
                        <h5 class="mb-0">
                           {{t("Image box settings text (Template/Document - section) - Image box settings")}}
                        </h5>
                    </div>
                </div>
            </div>
            <div class="cursor-pointer closeMenu" (click)="close()">
                <i data-feather="x" [size]="16" class="ms-0"></i>
            </div>
        </div>
        
        <div>
            <div class="form-group px-1 mt-0 conditional-dropdown">
                <app-conditional-fields
                    [uuid]="data['uuid']"
                    [block]="imageData"
                ></app-conditional-fields>
            </div>
        </div>
        <app-lock-field 
            type="block"
            [uuid]="data['uuid']"
            >
        </app-lock-field>
        <div class="d-flex px-1 mt-0 flex-column">
            <label class="col-form-label pt-0">{{ t("Image box settings label text (Template/Document - section) - Position") }}</label>
            <div class="btn-group btn-group-toggle" role="group">
                <button *ngFor="let pos of positions"
                        container="body"
                        placement="top"
                        [ngbTooltip]="t(pos.tooltipKey)"
                        type="button"
                        [class.active]="selectedPosition === pos.value"
                        class="btn btn-outline-primary"
                        (click)="setImagePosition(pos.value)">
                    <i [data-feather]="pos.icon"></i>
                </button>
            </div>
        </div>
    </div>
    </ng-container>
    